import * as actions from './leaveMaster/actions'
import * as mutations from './leaveMaster/mutations'
import * as getters from './leaveMaster/getters'

import { dataProps } from './leaveMaster/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/leaveMaster.js